var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewGridFill = function SvgViewGridFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11q-.824 0-1.412-.588A1.93 1.93 0 0 1 3 9V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h4q.825 0 1.412.587Q11 4.176 11 5v4q0 .825-.588 1.412A1.93 1.93 0 0 1 9 11zm0 10q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19v-4q0-.825.587-1.412A1.93 1.93 0 0 1 5 13h4q.825 0 1.412.588Q11 14.175 11 15v4q0 .824-.588 1.413A1.93 1.93 0 0 1 9 21zm10-10q-.825 0-1.412-.588A1.93 1.93 0 0 1 13 9V5q0-.824.588-1.412A1.93 1.93 0 0 1 15 3h4q.824 0 1.413.587Q21 4.176 21 5v4q0 .825-.587 1.412A1.93 1.93 0 0 1 19 11zm0 10q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 19v-4q0-.825.588-1.412A1.93 1.93 0 0 1 15 13h4q.824 0 1.413.588Q21 14.175 21 15v4q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewGridFill);
export { ForwardRef as ReactComponent };